import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CC STOCK CLOSE APIs
// Legacy route: /Purchase/CCStockClose
// ==============================================

// 1. Get Cost Centers eligible for stock close (GET)
export const getCCForCCStockClose = async ({ userId, roleId }) => {
    try {
        const queryParams = new URLSearchParams({ UserId: userId, Roleid: roleId });
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetCCForCCStockClose?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get CC For CC Stock Close API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Check the last stock close for a Cost Center (GET)
export const checkLastCCStockClose = async (ccCode) => {
    try {
        const queryParams = new URLSearchParams({ CCCode: ccCode });
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/CheckLastCCStockClose?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Check Last CC Stock Close API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get stock amounts for the CC / period (GET)
export const getCCStockAmount = async ({ ccCode, fromDate, toDate }) => {
    try {
        const queryParams = new URLSearchParams({ CCCode: ccCode, FromDate: fromDate, ToDate: toDate });
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetCCStockAmount?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Get CC Stock Amount API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Save the CC Stock Close entry (POST)
export const saveCCStockClose = async (params) => {
    try {
        const payload = {
            CCCode: params.ccCode,
            FromDate: params.fromDate,
            ToDate: params.toDate,
            TransactionType: params.transactionType,
            Amount: params.amount,
            TotalPurchaseAmt: params.totalPurchaseAmt,
            NewStockAmt: params.newStockAmt,
            OldStockAmt: params.oldStockAmt,
            DailyIssueAmt: params.dailyIssueAmt,
            Remarks: params.remarks,
            CurrentValue: params.currentValue,
            ClosingAmount: params.closingAmount,
            LastCloseId: params.lastCloseId,
            CreatedBy: params.createdBy,
            Roleid: params.roleId,
        };

        const response = await axios.post(
            `${API_BASE_URL}/Purchase/SaveCCStockClose`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Save CC Stock Close API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
